<template>
  <AppSidebar
    v-model="navigationDrawerProfile"
    :mini="mini"
  >
    <div class="app-sidebar-menu">
      <AppSidebarItem
        v-for="item in sidebarItems"
        :key="item.key"
        :item="item"
        :icon-only="mini"
        @select="selectProfileSection"
      />
    </div>
  </AppSidebar>
</template>

<script>
import { mapState } from 'vuex'

import AppSidebar from '@/common/app-sidebar/AppSidebar.vue'
import AppSidebarItem from '@/common/app-sidebar/AppSidebarItem.vue'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default {
  name: 'ProfileSidebar',
  props: ['profileSections'],
  components: { AppSidebar, AppSidebarItem },
  computed: {
    ...mapState('global', ['mini']),
    sidebarItems () {
      return this.profileSections.map(section => ({
        key: section.key,
        label: this.$t(section.title).toString(),
        icon: section.icon.replace(/^fa-/, ''),
        kind: 'nav',
        active: this.$route.path.startsWith(`/profile/${section.key}`),
        dataLocator: `profile-${section.key}-nav-item`,
        tag: section.isNew ? 'new' : undefined,
      }))
    },
    navigationDrawerProfile: {
      get: function () {
        return !this.$vuetify.display.mobile
          ? true
          : this.$store.state.global.navigationDrawerProfile
      },
      set: function (newValue) {
        if (!this.$vuetify.display.mobile) return
        this.$store.commit('global/' + GlobalMutationTypes.SET_NAVIGATION_DRAWER_PROFILE, newValue)
      },
    },
  },
  methods: {
    selectProfileSection (routeName) {
      this.$router.push({ path: `/profile/${routeName}` }).catch(() => {})
      this.navigationDrawerProfile = false
    },
  },
}
</script>
